import ProfileContainer from './ProfileContainer';

export default ProfileContainer;
